"use strict";

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAENavbarItems = void 0;

var _react = _interopRequireDefault(require("react"));

var _FAEText = require("../FAEText/FAEText");

require("./FAENavbarItems.scss");

const _excluded = ["label", "href"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const FAENavbarItems = _ref => {
  let {
    itemsList = []
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--navbar-items-container"
  }, itemsList.map((item, index) => {
    const {
      label,
      href = ""
    } = item,
          rest = _objectWithoutProperties(item, _excluded);

    return href === "" ? /*#__PURE__*/_react.default.createElement("div", {
      key: index
    }, /*#__PURE__*/_react.default.createElement("p", _extends({}, rest, {
      className: "fae--navbar-items-item"
    }), /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
      primary: true
    }, label)), index !== itemsList.length - 1 && /*#__PURE__*/_react.default.createElement("span", {
      className: "fae--navbar-items-divider"
    })) : /*#__PURE__*/_react.default.createElement("div", {
      key: index
    }, /*#__PURE__*/_react.default.createElement("a", {
      className: "fae--navbar-items-item",
      target: "_blank",
      href: href,
      rel: "noreferrer"
    }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
      primary: true
    }, label)), index !== itemsList.length - 1 && /*#__PURE__*/_react.default.createElement("span", {
      className: "fae--navbar-items-divider"
    }));
  })));
};

exports.FAENavbarItems = FAENavbarItems;